import { Info } from "lucide-react";

export function InfoTooltip() {
  return (
    <div className="relative group">
      <button
        type="button"
        className="flex h-5 w-5 items-center justify-center rounded-full border border-muted-foreground/40 text-muted-foreground hover:border-foreground hover:text-foreground transition-colors"
        aria-label="Information sur le format de réponse"
      >
        <Info className="h-3 w-3" />
      </button>
      <div className="pointer-events-none absolute bottom-full left-0 z-50 mb-2 w-96 rounded-surface border bg-popover p-3 text-xs text-popover-foreground shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-150">
        <div className="font-medium mb-1">
          Expliquer le &ldquo;POURQUOI&rdquo; : Pour chaque action importante
          que vous décidez de prendre (ou de ne pas prendre), expliquez
          clairement pourquoi vous faites ce choix.
        </div>
        <div>
          Quel est votre raisonnement ? Quels facteurs avez-vous pris en
          compte ?
        </div>
      </div>
    </div>
  );
}
